import React from "react";

interface IProps {
  stolenResources: string;
}

const DetailStolenResources = ({
  stolenResources
}: IProps) => <>
  {stolenResources.split(";")
    .map((r, index, resources) => r.includes(":") && <>
      <em>
        {r.split(":")[0]}
      </em>: {r.split(":")[1]}{index < resources.length && <>,<br/></>}
    </>)}
</>;

export default DetailStolenResources;
